<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <label> Compras/Solicitação </label>
    </div>
    <v-container fluid
      ><v-row align="center">
        <v-col cols="12" sm="1">
          <v-btn
            color="info"
            to="/solicitacao/criar"
            v-if="isAllowed(idModulo)"
            class="ma-2 white--text"
          >
            NOVO
          </v-btn>
        </v-col>
        <v-col cols="12" sm="8">
          <v-radio-group v-model="selectedFilter" row>
            <v-radio value="0">
              <template v-slot:label>
                <v-avatar size="25" color="primary">
                  <span class="white--text text-h6">TD</span>
                </v-avatar>
                <div class="ma-1 text-h5">Todas</div>
              </template></v-radio
            ><v-radio value="AA">
              <template v-slot:label>
                <v-avatar size="25" color="red">
                  <span class="white--text text-h6">AA</span>
                </v-avatar>
                <div class="ma-1 text-h5">Ag. Autorização</div>
              </template>
            </v-radio>
            <v-radio value="AG">
              <template v-slot:label>
                <v-avatar color="yellow" size="25">
                  <span class="white--text text-h6">AG</span>
                </v-avatar>
                <div class="ma-1 text-h5">Analisado Pelo Gestor</div>
              </template>
            </v-radio>
            <v-radio value="PC">
              <template v-slot:label>
                <v-avatar color="yellow" size="25">
                  <span class="white--text text-h6">PC</span>
                </v-avatar>
                <div class="ma-1 text-h5">Processo de Cotação</div>
              </template>
            </v-radio>
            <v-radio value="PP">
              <template v-slot:label>
                <v-avatar color="yellow" size="25">
                  <span class="white--text text-h6">PP</span>
                </v-avatar>
                <div class="ma-1 text-h5">Pedido Parcial</div>
              </template>
            </v-radio>
            <v-radio value="PG">
              <template v-slot:label>
                <v-avatar color="green" size="25">
                  <span class="white--text text-h6">PG</span>
                </v-avatar>
                <div class="ma-1 text-h5">Pedido Gerado</div>
              </template>
            </v-radio>
            <v-radio value="EP">
              <template v-slot:label>
                <v-avatar color="yellow" size="25">
                  <span class="white--text text-h6">EP</span>
                </v-avatar>
                <div class="ma-1 text-h5">Entrada Parcial</div>
              </template>
            </v-radio>
            <v-radio value="BX">
              <template v-slot:label>
                <v-avatar color="grey darken-1" size="25">
                  <span class="white--text text-h6">BX</span>
                </v-avatar>
                <div class="ma-1 text-h5">Solicitação Baixada</div>
              </template>
            </v-radio>
            <v-radio value="D">
              <template v-slot:label>
                <v-avatar color="grey darken-1" size="25">
                  <span class="white--text text-h6">D</span>
                </v-avatar>
                <div class="ma-1 text-h5">Declinada</div>
              </template>
            </v-radio>
            <v-radio value="I">
              <template v-slot:label>
                <v-avatar color="grey darken-1" size="25">
                  <span class="white--text text-h6">I</span>
                </v-avatar>
                <div class="ma-1 text-h5">Inativa</div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12" sm="2">
          <v-btn
            @click="baixarlista()"
            v-if="solicitacoes.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="right">
        <v-col cols="12" sm="4" md="3" class="text-left">
          <v-menu
            v-model="menuData1"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="computedDataIni"
                label="Data inicio"
                prepend-icon="mdi-calendar"
                v-mask="['##/##/####']"
                maxlength="10"
                v-bind="attrs"
                v-on="on"
                @input="onInputDate1"
                @click:clear="dataIni = null"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dataIni"
              @input="menuData1 = false"
              @change="dateChangeDataIni"
              :max="new Date().toISOString().substr(0, 10)"
              locale="pt-br"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="4" md="3" class="text-left">
          <v-menu
            v-model="menuData2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedDataFim"
                label="Data fim"
                prepend-icon="mdi-calendar"
                v-mask="['##/##/####']"
                maxlength="10"
                v-bind="attrs"
                v-on="on"
                @input="onInputDate2"
                @click:clear="dataFim = null"
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dataFim"
              @input="menuData2 = false"
              @change="dateChangeDataFim"
              locale="pt-br"
              forma
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <v-autocomplete
            v-model="departamentoSelected"
            :items="departamentos"
            label="Departamento"
            item-text="descricao"
            item-value="id"
            persistent-hint
            return-object
            clearable
            @click:clear="departamentoSelected = null"
          >
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        class="elevation-1"
        :loading="loading"
        loading-text="Buscando dados..."
        :options.sync="options"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
      >
        <template v-slot:item.status="{ item }">
          <v-avatar v-if="item.status == 'AA'" color="red" size="24">
            <span class="white--text text-h5">AA</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'AG'" color="yellow" size="24">
            <span class="white--text text-h5">AG</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'PC'" color="yellow" size="24">
            <span class="white--text text-h5">PC</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'PP'" color="yellow" size="24">
            <span class="white--text text-h5">PP</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'PG'" color="green" size="24">
            <span class="white--text text-h5">PG</span>
          </v-avatar>
          <v-avatar v-else-if="item.status == 'EP'" color="yellow" size="24">
            <span class="white--text text-h5">EP</span>
          </v-avatar>
          <v-avatar
            v-else-if="item.status == 'BX'"
            color="grey darken-1"
            size="24"
          >
            <span class="white--text text-h5">B</span>
          </v-avatar>
          <v-avatar
            v-else-if="item.status == 'D'"
            color="grey darken-1"
            size="24"
          >
            <span class="white--text text-h5">D</span>
          </v-avatar>
          <v-avatar v-else color="blue-grey lighten-4" size="24">
            <span class="white--text text-h5">I</span>
          </v-avatar>
        </template>
        <template v-slot:item.id="{ item }">
          {{ item.nome == null ? item.id : item.nome }}
        </template>
        <template v-slot:item.observacao="{ item }">
          <v-text-field v-model="item.observacao" :readonly="apenasLeitura">
          </v-text-field>
        </template>
        <template v-slot:item.idRequisicao="{ item }">
          <span v-if="item.idRequisicao && item.idRequisicao !== 0">
            <a
              href="#"
              @click.prevent="abrirPdfRequisicao(item)"
              class="text--primary font-weight-medium text-decoration-underline"
            >
              {{ item.idRequisicao }}
            </a>
          </span>
          <span v-else>—</span>
        </template>
        <template v-slot:item.pedidos="{ item }">
          <div v-if="item.pedidos && item.pedidos !== ''">
            <span
              v-for="(pedido, index) in item.pedidos.split(',')"
              :key="index"
            >
              <a
                href="#"
                @click.prevent="abrirPdfPedido(pedido)"
                class="text--primary font-weight-medium text-decoration-underline"
              >
                {{ pedido }}
              </a>
              <span v-if="index < item.pedidos.split(',').length - 1">, </span>
            </span>
          </div>
          <span v-else>—</span>
        </template>
        <template v-slot:item.mapasCotacao="{ item }">
          <div v-if="temMapasCotacao(item)" class="mapas-cotacao-lista">
            <span
              v-for="(mapa, index) in item.mapasCotacao"
              :key="mapa.id"
            >
              <a
                v-if="podeVisualizarMapaCotacao"
                href="#"
                @click.prevent="abrirMapaCotacao(mapa)"
                class="text--primary font-weight-medium text-decoration-underline"
              >
                MC {{ obterNumeroMapaCotacao(mapa) }}
              </a>
              <span v-else>MC {{ obterNumeroMapaCotacao(mapa) }}</span>
              <span v-if="index < item.mapasCotacao.length - 1">, </span>
            </span>
          </div>
          <span v-else>—</span>
        </template>
        <template v-slot:item.quantidade="{ item }">
          <v-text-field
            v-model="item.quantidade"
            hide-details
            single-line
            type="number"
            :readonly="apenasLeitura"
          >
          </v-text-field>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="show(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-file-search
              </v-icon>
            </template>
            <span>Visualizar em PDF</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editar(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span
              v-if="
                isAllowed(idModulo) && statusPermite(item) && item.mesmoSolicitante
              "
              >Editar</span
            >
            <span v-else>Visualizar</span>
          </v-tooltip>
          <v-tooltip v-if="isInactive(idModulo)" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="error"
                class="mr-2"
                @click="declinar(item)"
                v-bind="attrs"
                v-on="on"
                :disabled="!podeDeclinarRegistro(item)"
              >
                mdi-close-thick
              </v-icon>
            </template>
            <span>Inativar</span>
          </v-tooltip>
          <v-tooltip
            v-if="
              isAllowed(idModulo, item.idDepartamento) &&
              isApproving(idModulo) &&
              isValidDP(item.idDepartamento)
            "
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="success"
                class="mr-2"
                @click="autorizar(item)"
                v-bind="attrs"
                v-on="on"
                :disabled="!statusPermiteAprovar(item)"
              >
                mdi-check-bold
              </v-icon>
            </template>
            <span v-if="isAllowed(idModulo)">{{ textoTooltipAprovar(item) }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.dataCriado="{ item }">
          <span>{{
            new Date(item.dataCriado)
              .toLocaleString()
              .replace(/(.*)\D\d+/, "$1")
          }}</span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  canApproveModule,
  canDeclineModule,
  canInactivateModule,
  getUserDepartments,
  getUserPermission,
  getUserRoles,
  isLoggedUserAdmin,
  logApprovalDiagnostics,
  explainApprovalButtonState,
} from "@/services/loginService";
import { getPdf } from "../../../services/solicitacaoService";
import { getPdf as getRequisicaoPdf } from "../../../services/requisicaoService";
import { getPdf as getPedidoPdf } from "../../../services/pedidoService";
import { abrirJanelaPdf } from "@/services/pdfHelper";
import { saveAs } from "file-saver";
import moment from "moment";

export default {
  name: "listaSolicitacoes",
  data() {
    return {
      idModulo: 9,
      selectedFilter: "0",
      loading: false,
      search: "",
      showAtivo: false,
      apenasLeitura: false,
      active_tab: 2,
      dataIni: null,
      dataFim: null,
      menuData1: false,
      menuData2: false,
      arrayEvents: null,
      departamentoSelected: null,
      headers: [
        {
          text: "Solicitação",
          align: "start",
          value: "id",
        },
        { text: "Requisição", value: "idRequisicao" },
        { text: "Data Hora", value: "dataCriado" },
        { text: "UnidadeAdm", value: "unidadeAdm" },
        { text: "Solicitante", value: "solicitante" },
        { text: "Prioridade", value: "prioridade" },
        { text: "Departamento", value: "departamento" },
        { text: "Pedidos", value: "pedidos" },
        { text: "Mapas", value: "mapasCotacao", sortable: false, width: "10%" },
        { text: "Status", value: "status" },
        { text: "Ações", value: "actions", sortable: false, width: "18%" },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      filters: {
        id: [],
        idRequisicao: [],
        data: [],
        unidadeAdm: [],
        local: [],
        solicitante: [],
        prioridade: [],
        centroCusto: [],
      },
    };
  },
  computed: {
    ...mapState("solicitacao", ["solicitacoes"]),
    ...mapState("mapaCotacao", ["mapasCotacao"]),
    ...mapState("unidadeAdm", ["unidadesAdm"]),
    ...mapState("local", ["locais"]),
    ...mapState("centroCusto", ["centrosCusto"]),
    ...mapState("departamento", ["departamentos"]),
    podeVisualizarMapaCotacao() {
      return getUserPermission(10);
    },
    filteredList() {
      const searchNormalized = this.normalizarTexto(this.search);
      const departamentoSelecionado = this.normalizarTexto(
        this.departamentoSelected ? this.departamentoSelected.descricao : ""
      );

      return this.solicitacoes
        .filter((r) => {
          // 1. Busca textual (inclusive nos produtos)
          const buscaTexto = this.matchesBuscaSolicitacao(r, searchNormalized);

          // 2. Filtro por data (dataCriado)
          const dataValida =
            !this.dataIni ||
            !this.dataFim ||
            (new Date(r.dataCriado.split("T")[0]) >=
              new Date(this.dataIni.split("T")[0]) &&
              new Date(r.dataCriado.split("T")[0]) <=
                new Date(this.dataFim.split("T")[0]));

          // 3. Filtros refinados (via dropdown/multiselect)
          const filtrosOk = Object.keys(this.filters).every((f) => {
            if (this.filters[f].length < 1) return true;

            if (f === "data") {
              const dataFormatada = new Date(r.dataCriado)
                .toLocaleString()
                .replace(/(.*)\D\d+/, "$1");
              return this.filters[f].includes(dataFormatada);
            }

            if (f === "centroCusto") {
              return this.getItensSolicitacao(r).some((p) =>
                this.filters[f].includes(p.centroCusto)
              );
            }

            return this.filters[f].includes(r[f]);
          });

          // 4. Filtro por status
          const statusOk =
            this.selectedFilter === "0" || r.status === this.selectedFilter;

          const departamento =
            !departamentoSelecionado ||
            this.normalizarTexto(r.departamento).includes(departamentoSelecionado);

          return (
            buscaTexto && dataValida && filtrosOk && statusOk && departamento
          );
        })
        .sort((a, b) => b.id - a.id);
    },

    computedDataIni() {
      return this.dataIni ? moment(this.dataIni).format("DD/MM/YYYY") : null;
    },
    computedDataFim() {
      return this.dataFim ? moment(this.dataFim).format("DD/MM/YYYY") : null;
    },
  },
  methods: {
    ...mapActions("solicitacao", [
      "atualizarSolicitacao",
      "atualizarSolicitacoes",
    ]),
    ...mapActions("unidadeAdm", ["atualizarUnidadesAdm"]),
    ...mapActions("local", ["atualizarLocais"]),
    ...mapActions("centroCusto", ["atualizarCentrosCusto"]),
    ...mapActions("departamento", ["atualizarDepartamentos"]),
    ...mapActions("mapaCotacao", ["atualizarMapasCotacao", "atualizarMapaCotacao"]),

    columnValueList(val) {
      if (val == "data") {
        return this.solicitacoes.map((d) =>
          new Date(d[val]).toLocaleString().replace(/(.*)\D\d+/, "$1")
        );
      } else {
        return this.solicitacoes.map((d) => d[val]);
      }
    },
    normalizarTexto(valor) {
      return String(valor ?? "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
    contemTexto(valor, termo) {
      return this.normalizarTexto(valor).includes(termo);
    },
    getItensSolicitacao(solicitacao) {
      return solicitacao?.produtos || solicitacao?.itens || [];
    },
    matchesBuscaSolicitacao(solicitacao, termo) {
      if (!termo) return true;

      const camposCabecalho = [
        solicitacao.id,
        solicitacao.idRequisicao,
        solicitacao.dataCriado
          ? new Date(solicitacao.dataCriado)
              .toLocaleString()
              .replace(/(.*)\D\d+/, "$1")
          : "",
        solicitacao.unidadeAdm,
        solicitacao.local,
        solicitacao.solicitante,
        solicitacao.prioridade,
        solicitacao.departamento,
        solicitacao.pedidos,
        solicitacao.status,
        solicitacao.observacao,
        solicitacao.informacoesAdicionais,
      ];

      return (
        camposCabecalho.some((campo) => this.contemTexto(campo, termo)) ||
        this.getItensSolicitacao(solicitacao).some((produto) =>
          this.matchProduto(produto, termo)
        )
      );
    },
    matchProduto(p, termo) {
      if (!p || typeof p !== "object") return false;

      const campos = [
        p.descricao,
        p.produto,
        p.codigo,
        p.centroCusto,
        p.unidadeMedida,
        p.detalhe,
        p.observacao,
        p.departamento,
      ];

      return campos.some((campo) => this.contemTexto(campo, termo));
    },
    editar(solicitacao) {
      this.atualizarSolicitacao(solicitacao);
      if (this.isAllowed(this.idModulo) && this.statusPermite(solicitacao)) {
        this.$router.push({
          path: "/solicitacao/editar",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
      } else {
        this.$router.push({
          path: "/solicitacao/ver",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
      }
    },
    declinar(solicitacao) {
      this.atualizarSolicitacao(solicitacao);
      if (this.isInactive(this.idModulo) && this.podeDeclinarRegistro(solicitacao)) {
        this.$router.push({
          path: "/solicitacao/inativar",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
      } else {
        this.$router.push({
          path: "/solicitacao/ver",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
      }
    },
    autorizar(solicitacao) {
      this.atualizarSolicitacao(solicitacao);
        this.$router.push({
          path: "/solicitacao/aprovar",
          query: { ...this.$route.query, page: String(this.options?.page || 1) },
        });
    },
    doAjax() {
      if (!this.unidadesAdm || this.unidadesAdm.length == 0) {
        this.atualizarUnidadesAdm();
      }
      if (!this.locais || this.locais.length == 0) {
        this.atualizarLocais();
      }
      if (!this.centrosCusto || this.centrosCusto.length == 0) {
        this.atualizarCentrosCusto();
      }
    },
    async obter() {
      if (
        this.$store.getters["solicitacao/ultimaAtualizacaoListaSolicitacao"]
      ) {
        this.loading = true;
        await this.atualizarSolicitacoes();
        this.loading = false;
      }
    },
    async filtroDepartamento() {
      if (!this.departamentos || this.departamentos.length == 0) {
        await this.atualizarDepartamentos();
      }
      if (this.$route.query.selectedDepartment) {
        this.departamentoSelected = this.departamentos.find(
          (d) => d.descricao === this.$route.query.selectedDepartment
        );
      }
    },
    baixarlista() {
      //downloadLista();
      const blob = this.gerarExcel();
      const nome_arquivo = "solicitacoes.xlsx";
      saveAs(blob, nome_arquivo);
    },
    show(item) {
      getPdf(item.id, abrirJanelaPdf());
    },
    isAllowed(id) {
      return getUserPermission(id);
    },
    isApproving(id) {
      return canApproveModule(id) || canDeclineModule(id);
    },
    isValidDP(idDepartamento) {
      return getUserDepartments().includes(idDepartamento);
    },
    isInactive(id) {
      return canInactivateModule(id);
    },
    statusPermite(solicitacao) {
      return solicitacao.status === "AA";
    },
    statusPermiteInativar(solicitacao) {
      return ["AA", "AG", "PC", "PP"].includes(solicitacao.status);
    },
    possuiPedidoGerado(solicitacao) {
      return String(solicitacao?.pedidos || "").trim().length > 0;
    },
    podeDeclinarRegistro(solicitacao) {
      return (
        this.statusPermiteInativar(solicitacao) &&
        !this.possuiPedidoGerado(solicitacao) &&
        (solicitacao.mesmoSolicitante || isLoggedUserAdmin())
      );
    },
    statusPermiteAprovar(solicitacao) {
      const permite =
        solicitacao.status === "AA" ||
        solicitacao.status === "AG" ||
        solicitacao.status === "D";
      logApprovalDiagnostics("Solicitacao/Lista:Aprovar", explainApprovalButtonState({
        modulo: this.idModulo,
        registro: solicitacao,
        action: "aprovar",
        statusPermitidos: ["AA", "AG", "D"],
        departamentoObrigatorio: true,
        departamentosUsuario: getUserDepartments(),
      }));
      return permite;
    },
    statusPermiteDesaprovar(solicitacao) {
      return solicitacao.status === "AG";
    },
    textoTooltipAprovar(solicitacao) {
      return this.statusPermiteDesaprovar(solicitacao) ? "Desaprovar" : "Aprovar";
    },
    abrirPdfRequisicao(item) {
      getRequisicaoPdf(item.idRequisicao, abrirJanelaPdf());
    },
    abrirPdfPedido(pedido) {
      getPedidoPdf(pedido, abrirJanelaPdf());
    },
    temMapasCotacao(item) {
      return Array.isArray(item?.mapasCotacao) && item.mapasCotacao.length > 0;
    },
    obterNumeroMapaCotacao(mapa) {
      return mapa?.numero || mapa?.id;
    },
    async abrirMapaCotacao(mapa) {
      if (!this.podeVisualizarMapaCotacao || !mapa?.id) return;

      let mapaCotacao = (this.mapasCotacao || []).find((m) => m.id === mapa.id);
      if (!mapaCotacao) {
        await this.atualizarMapasCotacao();
        mapaCotacao = (this.mapasCotacao || []).find((m) => m.id === mapa.id);
      }

      if (!mapaCotacao) return;

      this.atualizarMapaCotacao(mapaCotacao);
      this.$router.push({
        path: "/mapaCotacao/ver",
        query: this.$route.query,
      });
    },
    getStyle(value) {
      if (value == "1") {
        return "Normal";
      } else if (value == 2) {
        return "Emergencial";
      } else if (value == 0) {
        return "NA";
      } else {
        return value;
      }
    },
    onInputDate1(val) {
      if (val.length == 10) {
        const newDate = moment(val, "DD/MM/YYYY");
        if (newDate.isValid() && newDate <= new Date()) {
          this.dataIni = moment(val, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataIni(date) {
      this.dataIni = date;
    },
    onInputDate2(val) {
      if (val.length == 10) {
        const newDate = moment(val, "DD/MM/YYYY");
        if (newDate.isValid()) {
          this.dataFim = moment(val, "DD/MM/YYYY").format("YYYY-MM-DD");
        }
      }
    },
    dateChangeDataFim(date) {
      this.dataFim = date;
    },
    gerarExcel() {
      const colunas = [
        { chave: "id", cabecalho: "Solicitação" },
        { chave: "dataCriado", cabecalho: "Data Hora" },
        { chave: "unidadeAdm", cabecalho: "UnidadeAdm" },
        { chave: "local", cabecalho: "Local de Entrega" },
        { chave: "solicitante", cabecalho: "Solicitante" },
        { chave: "prioridade", cabecalho: "Prioridade" },
        { chave: "idRequisicao", cabecalho: "Requisição" },
        { chave: "status", cabecalho: "Status" },
      ];

      const aoa = [];

      aoa.push(colunas.map((c) => c.cabecalho));

      this.filteredList.forEach((item) => {
        aoa.push(
          colunas.map((c) => {
            if (c.chave === "data") {
              return new Date(item[c.chave])
                .toLocaleString()
                .replace(/(.*)\D\d+/, "$1");
            } else if (c.chave === "idRequisicao") {
              return item[c.chave] === 0 ? "" : item[c.chave];
            } else {
              return item[c.chave];
            }
          })
        );
      });

      const ws = window.XLSX.utils.aoa_to_sheet(aoa);

      const larguras = colunas.map((col) => {
        const valores = [
          col.cabecalho,
          ...this.filteredList.map((d) => String(d[col.chave])),
        ];
        const larguraMaxima = Math.max(...valores.map((v) => v.length)) + 2;
        return { wch: larguraMaxima };
      });
      ws["!cols"] = larguras;

      const headerStyle = {
        font: { bold: true },
        alignment: { horizontal: "center" },
      };
      colunas.forEach((col, index) => {
        const colLetra = String.fromCharCode(65 + index); // A, B, C...
        const cell = ws[`${colLetra}1`];
        if (cell) cell.s = headerStyle;
      });
      const wb = window.XLSX.utils.book_new();
      window.XLSX.utils.book_append_sheet(wb, ws, "Planilha");

      const wbout = window.XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
        cellStyles: true,
      });

      return new Blob([wbout], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
    },
  },
  mounted() {
    this.readOnly = !getUserPermission(1);
  },
  watch: {
    "options.page"(p) {
      this.$router.replace({
        query: { ...this.$route.query, page: String(p) },
      });
    },

    "$route.query.page": {
      immediate: true,
      handler(val) {
        const qPage = parseInt(val, 10);
        const next = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
        if (next !== this.options.page) {
          this.options = { ...this.options, page: next };
        }
      },
    },
  },
  created: function () {
    const f = this.$route.query.selectedFilter;
    const allowed = ["0", "AA", "AG", "PC", "PP", "PG", "EP", "BX", "D", "I"];
    this.selectedFilter = allowed.includes(f) ? f : "0";
    //this.search = s;
    this.doAjax();
    this.obter();
    this.filtroDepartamento();

    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
    const qPage = parseInt(this.$route.query.page, 10);
    this.options.page = Number.isFinite(qPage) && qPage > 0 ? qPage : 1;
  },
};
</script>

<style scoped>
.mapas-cotacao-lista {
  max-width: 140px;
  white-space: normal;
  line-height: 1.4;
}
</style>
